module.exports = __webpack_public_path__ + "images/emoji/fearful.1462328c07daa81ddb10.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fearful.png
// module id = BqI7
// module chunks = 14